module.exports = "<header></header>\n<div [style.background-image]=\"'url('+hex+')'\" style=\"background-repeat:no-repeat; background-size:cover; text-align:center;padding:70px;\">\n  <div class=\"doNotPrint\" style=\"float:left; width:10%;\">&nbsp;</div>\n  <div class=\"doNotPrint\" style=\"float:right; width:10%;\">&nbsp;</div>\n  <div style=\"border: 1px gainsboro solid; text-align: left; padding:80px; width:80%;margin:0 auto !important; display:inline-block\" id=\"textBox\"> </div>\n</div>\n<footer></footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/publish/publish.component.html
// module id = ./src/app/publish/publish.component.html
// module chunks = main